module.exports = "/images/chat-bubbles-none.svg?dbadc033c3cf15889a8968cb044637bf";